export default {
  businessReceiptList: {
    search: {
      nameVoyageLicense: '船名航次',
      businessEntryNumber: '业务入库单号',
      warehouse: '仓库',
      incomingBatch: '入库批次号',
      businessWarehouseStart: '业务入库开始日期',
      businessWarehouseEnd: '业务入库截至日期',
      purchaseContract: '采购合同号',
      makingPeople: '制单人',
      company: '公司',
      department: '部门',
      supplier: '供应商',
      goods: '商品',
      createDateStart: '创建开始日期',
      createDateEnd: '创建截止日期',
      logisticsReceipt: '物流入库单号',
      SupplierDelivery: '供应商发货指令号',
      externalContract: '外部合同号',
      salesman: '业务员',
      intentionNumber: '意向单号',
      tradeType: '贸易类型',
      commodityDescription: '商品描述',
      productNo: '商品编号',
      productName: '商品名称',
      startGmtCreate: '入库日期开始',
      endGmtCreate: '入库日期结束',
      contractInternalNo: '采购合同号/意向单号',
      batchNo: '入库批次号',
      storageName: '仓库名称',
      partnerName: '供应商名称',
      marineLadingNo: '海运提单号',
      warehouseReceiptsNo: '仓单号',
      settleBatchNo: '结算批次',
      productDetailNo: '商品编码',
      externalContractNo: '外部合同号维护',
      matchedQuantity: '已匹配数量',
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
    },
    table: {
      pleaseMakeExchangeRate: '请维护当日汇率',
      batchNo: '入库批次号',
      storageQuantity: '库存数量',
      productName: '商品名称',
      gmtCreate: '创建日期',
      inboundNo: '单据号',
      contractInternalNo: '采购合同号/意向单号',
      businessUnitPriceWithTax: '入库单价',
      financeUnitPriceWithTax: '发票单价',
      inboundStatus: '业务状态',
      commodityDescription: '商品描述',
      identifyingCode: '商品识别码',
      inboundQuantity: '业务入库数量',
      purchaseContract: '采购合同数量',
      storageName: '仓库名称',
      productUnit: '计量单位',
      businessVariablePrice: '业务结算价',
      businessVariablePriceHn: '入库单价(业务结算价)',
      businessContractPrice: '合同价',
      businessVariablePriceWithTax: '业务结算价含税金额',
      businessVariablePricePureAmount: '业务结算价净值',
      businessContractPriceWithTax: '合同价含税金额',
      businessContractPricePureAmount: '合同价净值',
      contractPriceTax: '合同价税额',
      matchedQuantity: '已匹配数量',
      matchAvailableQuantity: '可匹配数量',
      taxRate: '税率',
      inboundDate: '业务入库日期',
      partnerName: '供应商名称',
      //gmtCreate: '创建日期',
      mark: '备注',
      purchaseReturnNo: '采购退换货单号',
      businessVariablePriceTax: '业务结算价税额',
      businessVariablePriceWithoutTax: '业务结算价不含税单价',
      accountingStatus: '入账状态',
      contractQuantity: '签约数量',
      businessContractPriceHN: '采购单价',
      shippingUnitExpense: '采购运费单价',
      salesUnitPrice: '销售单价',
      purchaseContractTotalAmount: '采购金额',
      salesContractTotalAmount: '销售金额',
    },
    errorTips: {
      inboundNoEmpty: '请勾选至少一个物流入库单创建业务入库单',
      notSameShipNo: '您选择的物流入库单无法合并，请选择相同发货指令和仓库下的物流入库单',
      overNumberTip: '业务入库总数大于剩余可业务入库总数',
      zeroInboundQuantity: '业务入库数不能为0',
    },
    create: {
      tagTitle: '业务入库单创建',
      tagTitleEdit: '业务入库单编辑',
      tagTitleSearch: '业务入库单查询',
      externalContractNo: '外部合同号',
      number: '数量',
      inboundDate: '入库日期',
      managementWay: '经营方式',
      personName: '人员',
      makeTime: '制单日期',
      statusTitle: '业务入库单状态',
      financeTitle: '财务信息',
      baseTitle: '基本信息',
      productTitle: '商品行项目',
      status: '业务入库单状态',
      financeStatus: '财务入库状态',
      accountingSatus: '入账状态',
      reversed: '是否已冲销',
      storageType: '入库类型',
      businessType: '业务性质',
      currency: '币种',
      entryDate: '入账日期',
      voucherNo: '凭证编号',
      writeOffDate: '冲销入账日期',
      writeOffVoucherNo: '冲销凭证号',
      purchaseContractLineNo: '采购合同行项目号',
      intentionNumberLine: '意向单行项目号',
      supplierDeliveryLine: '供应商发货指令行项目号',
      purchaseReturnLineNo: '采购退换货行项目号',
      matchedQuantity: '已匹配数量',
      canMatchQuantity: '可匹配数量',
      productUnit: '单位',
      remainInboundQuantity: '发货指令下可入数量',
      distributionInboundQuantity: '物流入库数量',
      inboundQuantity: '业务入库数',
      packing: '包装',
      unitWeight: '单位重量',
      // number: '件数',
      packNumber: '包装数量',
      packUnit: '包装单位',
      contractType: '合同类型',
      totalText: '合计',
      contractPriceEmpty: '合同变动价为空',
      detailNo: '行项目号',
      remaindMoreThanZero: '隐藏无可入',
      hideWithoutAccess: '隐藏无可入',
    },
    btnList: {
      createLogistics: '引用物流入库单创建',
      sterilisation: '冲销',
      copySelect: '复制所选行',
      delteSelect: '删除所选行',
    },
    message: {
      sureConfirm: '调拨过程出现损溢情况，请及时处理',
    },
  },
};
